import { Link } from '@solidjs/meta';

export function Questrial()
{
	return (<>
		<Link href='https://fonts.googleapis.com/css?family=Questrial&display=swap' rel='stylesheet' /> 
		<Link rel='preconnect' href='https://fonts.googleapis.com' />
		<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin='' />
		<Link href='https://fonts.googleapis.com/css2?family=Open+Sans:ital@1&family=REM:wght@700&display=swap' rel='stylesheet' />
	</>);
}

Questrial.fontFamily = '"Questrial", sans-serif';
